import { render } from "./ProductFamilyDetailsComponent.vue?vue&type=template&id=2b97e8fc&scoped=true"
import script from "./ProductFamilyDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ProductFamilyDetailsComponent.vue?vue&type=script&lang=js"

import "./ProductFamilyDetailsComponent.vue?vue&type=style&index=0&id=2b97e8fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97e8fc"]])

export default __exports__